import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: resolve => require(['@/view/HomePage'], resolve),
      meta: {
        title: '北海带恩 | 首页'
      }
    }, 
    {
      path: '/software',
      name: 'software',
      component: resolve => require(['@/view/Software'], resolve),
      meta: {
        title: '北海带恩 | 产品中心'
      },
    }, {
      path: '/service',
      name: 'service',
      component: resolve => require(['@/view/Service'], resolve),
      meta: {
        title: '北海带恩 | 相关服务'
      }
    }, {
      path: '/newsinformation',
      name: 'newsinformation',
      component: resolve => require(['@/view/NewsInformation'], resolve),
      meta: {
        title: '北海带恩 | 咨询中心'
      }
    },
    {
      path: '/casecenter',
      name: 'casecenter',
      component: resolve => require(['@/view/CaseCenter'], resolve),
      meta: {
        title: '北海带恩 | 案例中心'
      }
    },
     {
      path: '/companyintroduction',
      name: 'companyintroduction',
      component: resolve => require(['@/view/CompanyIntroduction'], resolve),
      meta: {
        title: '北海带恩 | 关于我们'
      }
    }, {
      path: '/jobchance',
      name: 'jobchance',
      component: resolve => require(['@/view/JobChance'], resolve),
      meta: {
        title: '北海带恩 | 工作机会'
      }
    }, {
      path: '/contactus',
      name: 'contactus',
      component: resolve => require(['@/view/ContactUs'], resolve),
      meta: {
        title: '北海带恩 | 联系我们'
      }
    },
    {
      path: '/servicedetail',
      name: 'servicedetail',
      component: resolve => require(['@/view/ServiceDetail'],resolve),
      meta: {
        title: '北海带恩 | 相关服务详情'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js